<p-tabs [value]="activeTab()" *ngIf="!isOpened" class="accounting-model-tabs">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    @for (tab of tabs; track tab) {
    <p-tab (click)="selectTab(tab)" [value]="tab">{{tab}}</p-tab>
    }
    <app-custom-button class="widthBtns" [title]="'Nuevo Registro'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
      [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
      (onClick)="createNewRegister()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="mt-2">
    <p-tabpanel value="Captura de Datos">
      <app-register-accounting-model *ngIf="activeTab() === tabs[0]"></app-register-accounting-model>
    </p-tabpanel>
    <p-tabpanel value="Configuración Concepto">
      <app-concept-invoicing-for-accounting-model></app-concept-invoicing-for-accounting-model>
    </p-tabpanel>
    <p-tabpanel value="Consulta Concepto - Familia">
      <app-concept-family-for-accounting-model></app-concept-family-for-accounting-model>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>